import ScrollReveal from './ScrollReveal';

const featureBadges = [
  { icon: 'ri-global-line', text: '100% Online' },
  { icon: 'ri-time-line', text: 'Acceso de por vida' },
  { icon: 'ri-refresh-line', text: 'Contenido actualizado' },
  { icon: 'ri-money-dollar-circle-line', text: 'Pago único' },
];

const trustBadges = [
  { icon: 'ri-shield-check-line', text: 'Pago Seguro' },
  { icon: 'ri-flashlight-line', text: 'Acceso Inmediato' },
  { icon: 'ri-verified-badge-line', text: 'Garantía Hotmart' },
];

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center bg-[#FFFFFF] overflow-hidden pt-20 pb-16">
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-[#E53935]/[0.03] rounded-full blur-3xl -translate-y-1/3 translate-x-1/4 pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-[#C8A24A]/[0.04] rounded-full blur-3xl translate-y-1/3 -translate-x-1/4 pointer-events-none"></div>

      <div className="mx-auto max-w-[1280px] w-full px-6 md:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          {/* LEFT SIDE */}
          <div className="flex-1 w-full lg:max-w-[580px]">
            <ScrollReveal>
              <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#F7F8FA] border border-[#E53935]/10 text-[#E53935] text-xs font-semibold tracking-wider uppercase mb-6">
                <i className="ri-live-line text-sm"></i>
                Taller Online
              </span>
            </ScrollReveal>

            <ScrollReveal delay={100}>
              <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-[#111111] leading-[1.1] mb-5">
                Taller{' '}
                <span
                  className="text-transparent bg-clip-text"
                  style={{
                    backgroundImage: 'linear-gradient(135deg, #E53935 0%, #B71C1C 50%, #E53935 100%)',
                    backgroundSize: '200% 200%',
                  }}
                >
                  Vende +
                </span>
                <br />
                con IA
              </h1>
            </ScrollReveal>

            <ScrollReveal delay={200}>
              <p className="text-[#555555] text-base md:text-lg leading-relaxed mb-8 max-w-[520px]">
                Aprende paso a paso a crear campañas publicitarias exitosas en Meta Ads utilizando Inteligencia Artificial para atraer clientes, aumentar tus ventas y construir campañas profesionales.
              </p>
            </ScrollReveal>

            <ScrollReveal delay={300}>
              <div className="flex flex-wrap gap-3 mb-8">
                {featureBadges.map((badge) => (
                  <span
                    key={badge.text}
                    className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full bg-[#F7F8FA] text-[#333333] text-xs font-medium border border-gray-100 whitespace-nowrap"
                  >
                    <i className={`${badge.icon} text-[#E53935] text-sm`}></i>
                    {badge.text}
                  </span>
                ))}
              </div>
            </ScrollReveal>

            <ScrollReveal delay={400}>
              <div className="flex items-baseline gap-3 mb-8">
                <span className="text-4xl md:text-5xl font-bold text-[#111111] font-heading">$9.9 USD</span>
              </div>
            </ScrollReveal>

            <ScrollReveal delay={500}>
              <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 mb-8">
                <a
                  href="https://pay.hotmart.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-[#E53935] text-white font-semibold text-sm hover:bg-[#B71C1C] transition-all duration-300 whitespace-nowrap shadow-[0_4px_20px_rgba(229,57,53,0.3)] hover:shadow-[0_6px_28px_rgba(229,57,53,0.45)] hover:-translate-y-0.5 cursor-pointer"
                >
                  <i className="ri-shopping-bag-3-line text-lg"></i>
                  Comprar en Hotmart
                </a>
                <a
                  href="#course-content"
                  className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full border-2 border-[#111111] text-[#111111] font-semibold text-sm hover:bg-[#111111] hover:text-white transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-book-open-line text-lg"></i>
                  Ver Temario
                </a>
              </div>
            </ScrollReveal>

            <ScrollReveal delay={600}>
              <div className="flex flex-wrap items-center gap-5 pt-4 border-t border-gray-100">
                {trustBadges.map((badge) => (
                  <span key={badge.text} className="inline-flex items-center gap-1.5 text-xs text-[#666666]">
                    <i className={`${badge.icon} text-[#C8A24A] text-sm`}></i>
                    {badge.text}
                  </span>
                ))}
              </div>
            </ScrollReveal>
          </div>

          {/* RIGHT SIDE */}
          <div className="flex-1 w-full lg:max-w-[580px] relative">
            <div className="relative flex items-center justify-center">
              {/* Main mockup */}
              <div className="relative z-10">
                <div className="absolute inset-0 bg-gradient-to-tr from-[#E53935]/20 via-transparent to-[#C8A24A]/10 rounded-2xl blur-2xl scale-110"></div>
                <img
                  src="https://static.readdy.ai/image/ea473d33d180c87428df5c28ba90939d/d3c95b5d651cb556080a85d0f084641c.jpeg"
                  alt="Taller Vende + con IA - Meta Ads dashboard on laptop"
                  title="Taller Vende + con IA - Curso de Meta Ads con Inteligencia Artificial"
                  className="w-full max-w-[500px] h-auto object-contain rounded-2xl"
                />
              </div>

              {/* Floating card 1 */}
              <div className="absolute top-0 right-0 z-20 bg-white/80 backdrop-blur-xl rounded-xl shadow-[0_8px_30px_rgba(0,0,0,0.06)] border border-white/60 p-4 flex items-center gap-3 animate-float-slow">
                <div className="w-10 h-10 rounded-lg bg-[#E53935]/10 flex items-center justify-center flex-shrink-0">
                  <i className="ri-robot-2-line text-[#E53935] text-lg"></i>
                </div>
                <div>
                  <div className="text-xs font-semibold text-[#111111] whitespace-nowrap">IA Avanzada</div>
                  <div className="text-[10px] text-[#888888]">Optimización automática</div>
                </div>
              </div>

              {/* Floating card 2 */}
              <div className="absolute bottom-16 -left-4 z-20 bg-white/80 backdrop-blur-xl rounded-xl shadow-[0_8px_30px_rgba(0,0,0,0.06)] border border-white/60 p-4 flex items-center gap-3 animate-float-wide">
                <div className="w-10 h-10 rounded-lg bg-[#C8A24A]/10 flex items-center justify-center flex-shrink-0">
                  <i className="ri-bar-chart-grouped-line text-[#C8A24A] text-lg"></i>
                </div>
                <div>
                  <div className="text-xs font-semibold text-[#111111] whitespace-nowrap">3.2 ROAS</div>
                  <div className="text-[10px] text-[#888888]">Resultados reales</div>
                </div>
              </div>

              {/* Floating card 3 */}
              <div className="absolute top-1/3 -right-3 z-20 bg-white/80 backdrop-blur-xl rounded-full shadow-[0_8px_30px_rgba(0,0,0,0.06)] border border-white/60 px-4 py-2 flex items-center gap-2 animate-float">
                <div className="w-2 h-2 rounded-full bg-[#E53935] animate-pulse"></div>
                <span className="text-xs font-semibold text-[#111111] whitespace-nowrap">Meta Ads</span>
              </div>

              {/* Gold accent dot */}
              <div className="absolute top-12 left-8 w-3 h-3 rounded-full bg-[#C8A24A]/40 blur-[2px] animate-pulse-glow"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}